<template>
  <v-container grid-list-lg>
    <slot>
    </slot>
    <v-layout row wrap>
      <v-flex md3>
        <v-flex xs12>
          <h3>
            {{ availableFieldsLabelText }}
          </h3>
        </v-flex>
        <v-flex xs12 class="drag-container" :class="dragAreaClass">
          <vue-perfect-scrollbar>
            <v-flex xs12 class="drag-area">
              <draggable
                class="droppable-area"
                v-model="fields"
                :class="dragAreaClass"
                :group="allFields"
                @start="start"
                @end="end">
                <div class="d-inline-block draggable-block" v-for="field in fields" :key="field.key">
                  <v-chip class="btn-draggable" :disabled="true">
                    <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270 512" class="svg-inline--fa fa-grip-vertical fa-w-10"><path fill="currentColor" d="M64 208c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM16 104c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm0 304c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z M204 208c26.5 0 48 21.5 48 48s-21.5 48 -48 48 -48 -21.5 -48 -48 21.5 -48 48 -48zM156 104c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48zm0 304c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48z" class=""></path></svg>
                    {{ field.label }}
                  </v-chip>
                </div>
              </draggable>
            </v-flex>
          </vue-perfect-scrollbar>
        </v-flex>
      </v-flex>
      <v-flex md3>
        <v-flex xs12>
          <h3>
            {{ fieldsLabelText }}
          </h3>
        </v-flex>
        <v-flex xs12 class="drag-container" :class="dragAreaClass">
          <vue-perfect-scrollbar>
            <v-flex xs12 class="drag-area">
              <draggable
                class="droppable-area"
                v-model="internal.fields" 
                :class="dragAreaClass"
                :group="activeFields"
                @start="start"
                @end="end" >
                <div class="d-inline-block draggable-block" v-for="field in internal.fields" :key="field.key">
                  <v-chip class="btn-draggable k-orange-linear">
                    <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270 512" class="svg-inline--fa fa-grip-vertical fa-w-10"><path fill="currentColor" d="M64 208c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM16 104c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm0 304c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z M204 208c26.5 0 48 21.5 48 48s-21.5 48 -48 48 -48 -21.5 -48 -48 21.5 -48 48 -48zM156 104c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48zm0 304c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48z" class=""></path></svg>
                    {{ field.label }}
                  </v-chip>
                </div>
              </draggable>
            </v-flex>
          </vue-perfect-scrollbar>
        </v-flex>
      </v-flex>
      <v-flex md3>
        <v-flex xs12>
          <h3>
            {{ availableColumsLabelText }}
          </h3>
        </v-flex>
        <v-flex xs12 class="drag-container" :class="dragAreaClass">
          <vue-perfect-scrollbar>
            <v-flex xs12 class="drag-area">
              <draggable
                class="droppable-area"
                v-model="columns"
                :class="dragAreaClass"
                :group="allColumns"
                @start="start"
                @end="end">
                <div class="d-inline-block draggable-block" v-for="field in columns" :key="field.key">
                  <v-chip class="btn-draggable" :disabled="true">
                    <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270 512" class="svg-inline--fa fa-grip-vertical fa-w-10"><path fill="currentColor" d="M64 208c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM16 104c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm0 304c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z M204 208c26.5 0 48 21.5 48 48s-21.5 48 -48 48 -48 -21.5 -48 -48 21.5 -48 48 -48zM156 104c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48zm0 304c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48z" class=""></path></svg>
                    {{ field.label }}
                  </v-chip>
                </div>
              </draggable>
            </v-flex>
          </vue-perfect-scrollbar>
        </v-flex>
      </v-flex>
      <v-flex md3>
        <v-flex xs12>
          <h3>
            {{ columnsLabelText }}
          </h3>
        </v-flex>
        <v-flex xs12 class="drag-container" :class="dragAreaClass">
          <vue-perfect-scrollbar>
            <v-flex xs12 class="drag-area">
              <draggable
                class="droppable-area"
                v-model="internal.columns" 
                :class="dragAreaClass"
                :group="activeColumns"
                @start="start"
                @end="end" >
                <div class="d-inline-block draggable-block" v-for="field in internal.columns" :key="field.key">
                  <v-chip class="btn-draggable k-orange-linear">
                    <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270 512" class="svg-inline--fa fa-grip-vertical fa-w-10"><path fill="currentColor" d="M64 208c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM16 104c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm0 304c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z M204 208c26.5 0 48 21.5 48 48s-21.5 48 -48 48 -48 -21.5 -48 -48 21.5 -48 48 -48zM156 104c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48zm0 304c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48z" class=""></path></svg>
                    {{ field.label }}
                  </v-chip>
                </div>
              </draggable>
            </v-flex>
          </vue-perfect-scrollbar>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="pivotDataV2.length">
      <v-flex xs12>
        <div ref="tableContainer">
          <vue-perfect-scrollbar>
            <pivot-table
              :data="pivotDataV2"
              :headers="headers"
              :totals="totals"
              :fields="internal.fields"
              :columns="internal.columns"
              :columns-count="headers.length">
            </pivot-table>
          </vue-perfect-scrollbar>
        </div>
        <v-layout row wrap mt-3 justify-center>
          <v-pagination
            v-if="total > 1"
            color="k-orange-linear"
            :circle="true"
            :length="total"
            :total-visible="range"
            :value="(offset + 1)"
            @input="changePage">
          </v-pagination>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center v-else>
      <v-flex xs5>
        <v-list-tile class="ml-2">
          <v-list-tile-avatar>
            <v-icon medium>info_outline</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <span>No se encontraron datos</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import Draggable from 'vuedraggable';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import PivotTable from '@/components/global/report_datatables/PivotTable';
import PivotHeader from '@/components/global/report_datatables/PivotHeader';

export default {
  name: 'vue-pivot',
  props: {
    data: {
      type: Array,
      default: () => {},
    },
    filters: {
      type: Object,
      default: () => {},
    },
    fieldsList: {
      type: Array,
      default: () => [],
    },
    columnsList: {
      type: Array,
      default: () => [],
    },
    range: {
      type: Number,
      default: 10,
    },
    columnsLabelText: {
      type: String,
      default: 'Columnas activas',
    },
    fieldsLabelText: {
      type: String,
      default: 'Filtros activos',
    },
    availableColumsLabelText: {
      type: String,
      default: 'Columnas disponibles',
    },
    availableFieldsLabelText: {
      type: String,
      default: 'Filtros disponibles',
    },
    defaultColumns: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Draggable,
    PivotTable,
    PivotHeader,
    VuePerfectScrollbar,
  },
  mounted() {
    this.updateTable();
  },
  data() {
    return {
      count: [],
      offset: 0,
      reducer: (sum, item) => sum + item.count,
      internal: {
        fields: [],
        columns: [
          ...this.defaultColumns,
        ],
      },
      fields: this.fieldsList,
      columns: this.columnsList,
      dragging: false,
      dateMenu: false,
      isSearching: false,
      cancelToken: this.axios.CancelToken.source(),
      allFields: {
        name: 'allFields',
        pull: ['allFields', 'dimention'],
        put: ['allFields', 'dimention'],
      },
      activeFields: {
        name: 'dimention',
        pull: ['allFields', 'dimention'],
        put: ['allFields', 'dimention'],
      },
      allColumns: {
        name: 'allColumns',
        pull: ['allColumns', 'column'],
        put: ['allColumns', 'column'],
      },
      activeColumns: {
        name: 'column',
        pull: ['allColumns', 'column'],
        put: ['allColumns', 'column'],
      },
    };
  },
  computed: {
    formatDate() {
      let format = 'DD/MM/YYYY';
      if (this.fields.type === 'month') {
        format = 'MM/YYYY';
      }
      return moment(this.fields.date).format(format);
    },
    dragAreaClass() {
      return this.dragging ? 'drag-area-highlight' : null;
    },
    pivotData() {
      if (this.data.length) {
        return this.data.reduce((rows, row) => {
          this.internal.fields
            .reduce((columns, column) => {
              let temp = columns.find(item => item[column.value] === row[column.value]);
              if (!temp) {
                temp = {
                  [column.value]: row[column.value],
                  data: [],
                };
                columns.push(temp);
              }
              return temp.data;
            }, rows)
            .push(Object.assign({}, ...this.internal.columns
              .map(column => ({ [column.value]: row[column.value] }))));
          return rows;
        }, []);
      }
      return [];
    },
    pivotDataV2() {
      const columns = this.headers; // se agarran de los chips
      const rows = [];
      for (let i = 0; i < this.data.length; i += 1) {
        rows[i] = [];
        const before = [];
        for (let b = 0; b < columns.length; b += 1) {
          const column = columns[b].value;
          const value = this.data[i][column];
          before.push({
            [column]: value,
          });
          const obj = before.reduce((prev, current) => ({
            ...prev,
            ...current,
          }), {});
          const rowspan = this.data.filter((item) => {
            const current = _.pick(item, columns.map(col => col.value).slice(0, b + 1));
            return JSON.stringify(current) === JSON.stringify(obj);
          }).length;
          rows[i].push({
            key: Object.values(obj).join('-'),
            type: column,
            value,
            rowspan,
          });
        }
      }
      return rows;
    },
    queryColumns() {
      return this.internal.columns.length ? this.internal.columns.map(item => item.value) : [];
    },
    queryFields() {
      return this.internal.fields.length ? this.internal.fields.map(item => item.value) : [];
    },
    headers() {
      return [
        ...this.internal.fields,
        ...this.internal.columns,
      ];
    },
    page() {
      return this.offset + 1;
    },
    total() {
      if (this.count.length) {
        return Math.ceil(this.count[0].total / 60);
      }
      return 0;
    },
    totals() {
      const totals = [];
      this.internal.columns.forEach((item) => {
        totals.push({
          type: item.value,
          label: item.label,
          value: this.data.reduce((val, dat) => {
            if (this.isInt(dat[item.value])) {
              return val + parseInt(dat[item.value], 10);
            }
            return parseFloat(val, 10) + parseFloat(dat[item.value], 10);
          }, 0),
        });
      });
      return totals;
    },
  },
  filters: {
    formatNumber(value) {
      return new Intl.NumberFormat('es-VE', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(value);
    },
  },
  methods: {
    isInt(n) {
      return Number(n) === n && n % 1 === 0;
    },
    changePage($event) {
      this.offset = $event - 1;
    },
    changePicker() {
      this.dateMenu = false;
    },
    updateTable() {
      this.$emit('loading');
      const obj = {
        timeout: 300000,
      };
      if (this.isSearching) {
        obj.cancelToken = this.cancelToken.token;
      }
      this.isSearching = true;
      this.axios.get('reports/pivot', {
        params: {
          ...this.filters,
          columns: this.queryColumns,
          fields: this.queryFields,
          offset: this.offset,
        },
        cancelToken: this.cancelToken.token,
      }, obj).then(({ data }) => {
        this.isSearching = false;
        this.count = data.total;
        this.$emit('loaded', data.data);
      }).catch(() => {
        this.isSearching = false;
      });
    },
    cancelRequest() {
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
    },
    start() {
      this.dragging = true;
    },
    end() {
      this.dragging = false;
    },
  },
  watch: {
    fieldsList(value) {
      this.fields = value;
    },
    columnsList(value) {
      this.columns = value;
    },
    internal: {
      deep: true,
      handler() {
        this.cancelRequest();
        this.updateTable();
        this.offset = 0;
      },
    },
    filters: {
      deep: true,
      handler() {
        this.cancelRequest();
        this.updateTable();
        this.offset = 0;
      },
    },
    offset() {
      this.updateTable();
    },
  },
};
</script>

<style scoped>
  .border-bottom-1--gray:not(:last-child) {
    border-bottom: 1px solid #dddcdc;
  }
  .pivot-list .list__tile__sub-title, .list__tile__title {
    overflow: initial;
    white-space: normal;
  }
  .left-col {
    min-width: 200px;
    max-width: 200px;
  }

  /* Grid with even gutters */
  .grid-x {
    margin: 0 -0.75rem;
  }
  .grid-x > * {
    padding: 0 0.75rem;
  }
  /* Drag & drop stuff */
  .drag-container {
    border: 1px dashed #ccc;
  }
  .drag-area {
    height: 125px;
    min-width: 10rem;
    max-height: 125px;
    padding: 0.5rem;
    transition: background-color 0.4s;
  }
  .drag-area .droppable-area {
    min-height: 100%;
  }
  .drag-area .draggable-block .chip >>> .chip__content {
    cursor: move !important;
  }

  .drag-area-highlight {
    background-color: #f3f3f3;
  }

  .drag-area-label {
    position: absolute;
    padding: 0.75rem 1rem;
  }

  .sortable-ghost {
    opacity: 0.4;
  }
  /* Handle icon (mix of grip-vertical & ellipsis-v) */
  .svg-inline--fa.fa-w-10 {
    width: 0.625em;
  }

  .svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -.125em;
  }

  .btn-draggable .fa-grip-vertical {
    margin-left: -0.375rem;
    margin-right: 0.375rem;
  }
  /* Draggable buttons */
  .btn-draggable {
    white-space: normal;
    text-align: left;
  }
  .bordered-all-2 {
    border: 2px solid #d3d3d3;
  }
  .border-rounded {
    border-radius: 6px;
  }
  .table {
    display: table;
    margin: 0 auto;
  }
  .table-body {
    border-right: 1px solid #d3d3d3;
    border-bottom: 1px solid #d3d3d3;
    border-collapse: collapse;
    display: table-row-group;
  }
  .table-row {
    width: auto;
    clear: both;
    display: table-row;
  }
  .table-header {
    padding: 1em;
    display: table-cell;
    min-width: 150px;
    max-width: 150px;
  }
  .table-footer {
    display: table;
    border-collapse: collapse;
  }
  .border-top {
    border-top: 1px solid #d3d3d3;
  }
  .border-left {
    border-left: 1px solid #d3d3d3;
  }
  .border-right {
    border-right: 1px solid #d3d3d3;
  }
  .border-bottom {
    border-bottom: 1px solid #d3d3d3;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/report_datatables/Pivot.vue